import { Injectable, inject } from '@angular/core';
import { Feature } from '@shared/constants/feature';
import { Observable, tap, BehaviorSubject } from 'rxjs';
import { RestApiService } from './rest-api.service';
import { Entity } from '@shared/constants/entity';

/** Stores features enabled for current user. Serves as feature flags. */
@Injectable({ providedIn: 'root' })
export class FeaturesService {
  private api = inject(RestApiService);

  private userFeatures$ = new BehaviorSubject<Feature[]>([]);
  private loaded = false;
  private loading = false;

  getFeatures(): Observable<Feature[]> {
    if (!this.loaded && !this.loading) {
      this.loading = true;
      return this.api.getCustom<Feature[]>(`${Entity.User}/getFeatures`).pipe(
        tap(feats => {
          this.userFeatures$.next(feats);
          this.loaded = true;
          this.loading = false;
        })
      );
    } else {
      return this.userFeatures$;
    }
  }

  hasFeature(feature: Feature): boolean {
    return this.userFeatures$.getValue().includes(feature);
  }
}
